import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'vapsilver-age-verified';

export default function AgeGate() {
  const [verified, setVerified] = useState<boolean>(true);
  const [day, setDay] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [accepted, setAccepted] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored !== 'true') setVerified(false);
  }, []);

  if (verified) return null;

  const confirm = () => {
    setError(null);
    const d = parseInt(day, 10);
    const m = parseInt(month, 10);
    const y = parseInt(year, 10);
    if (!d || !m || !y || y < 1900 || y > new Date().getFullYear()) {
      setError('Introduce una fecha de nacimiento válida.');
      return;
    }
    const dob = new Date(y, m - 1, d);
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) age--;
    if (age < 18) {
      setError('Acceso restringido. Esta web es exclusiva para personas mayores de 18 años.');
      return;
    }
    if (!accepted) {
      setError('Debes aceptar la confirmación legal para continuar.');
      return;
    }
    localStorage.setItem(STORAGE_KEY, 'true');
    localStorage.setItem('vapsilver-age-verified-at', new Date().toISOString());
    setVerified(true);
  };

  const reject = () => {
    window.location.href = 'https://www.sanidad.gob.es/';
  };

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-ink-950/95 backdrop-blur-md p-5"
      role="dialog"
      aria-modal="true"
      aria-labelledby="age-gate-title"
    >
      <div className="card max-w-lg w-full p-8 sm:p-10 shadow-elev">
        <div className="flex items-center gap-2 mb-6">
          <div className="h-2 w-2 rounded-full bg-vapor-400 animate-pulse" />
          <span className="text-xs uppercase tracking-widest text-bone-300">Verificación obligatoria</span>
        </div>

        <h1 id="age-gate-title" className="text-3xl sm:text-4xl font-semibold tracking-tighter mb-3">
          Esta web es solo para mayores de 18 años
        </h1>
        <p className="text-bone-300 mb-6">
          La venta y promoción de productos de vapeo está restringida por la
          {' '}<strong className="text-bone-100">Ley 28/2005</strong> y el
          {' '}<strong className="text-bone-100">RD 579/2017</strong>. Confirma tu
          fecha de nacimiento para continuar.
        </p>

        <div className="grid grid-cols-3 gap-3 mb-4">
          <div>
            <label className="label" htmlFor="age-day">Día</label>
            <input id="age-day" inputMode="numeric" maxLength={2} value={day}
              onChange={(e) => setDay(e.target.value.replace(/\D/g, ''))} placeholder="DD" className="input text-center" />
          </div>
          <div>
            <label className="label" htmlFor="age-month">Mes</label>
            <input id="age-month" inputMode="numeric" maxLength={2} value={month}
              onChange={(e) => setMonth(e.target.value.replace(/\D/g, ''))} placeholder="MM" className="input text-center" />
          </div>
          <div>
            <label className="label" htmlFor="age-year">Año</label>
            <input id="age-year" inputMode="numeric" maxLength={4} value={year}
              onChange={(e) => setYear(e.target.value.replace(/\D/g, ''))} placeholder="AAAA" className="input text-center" />
          </div>
        </div>

        <label className="flex items-start gap-3 mb-5 cursor-pointer text-sm text-bone-200">
          <input
            type="checkbox"
            checked={accepted}
            onChange={(e) => setAccepted(e.target.checked)}
            className="mt-1 h-4 w-4 accent-vapor-400"
          />
          <span>
            Declaro bajo mi responsabilidad que soy mayor de 18 años y acepto los
            {' '}<Link className="text-vapor-400 underline" to="/terminos-condiciones">términos de venta</Link>{' '}
            y la
            {' '}<Link className="text-vapor-400 underline" to="/politica-privacidad">política de privacidad</Link>.
          </span>
        </label>

        {error && (
          <p role="alert" className="text-sm text-ember-400 mb-4">{error}</p>
        )}

        <div className="flex flex-col-reverse sm:flex-row gap-3">
          <button onClick={reject} className="btn-ghost flex-1">Soy menor de edad</button>
          <button onClick={confirm} className="btn-primary flex-1">Acceder a la tienda</button>
        </div>

        <p className="text-[11px] text-bone-400 mt-6 leading-relaxed">
          El consumo de nicotina es perjudicial para la salud y crea adicción. Este
          sitio no promociona el vapeo como hábito saludable. La verificación de edad
          también puede realizarse mediante sistemas documentales en el momento de la
          entrega del pedido.
        </p>
      </div>
    </div>
  );
}
